//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'privacy')
    ])
  },
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages
    }),
  },
  head() {
    return {
      title: this.pages.privacy && this.pages.privacy.seo ? this.pages.privacy.seo.title : 'Privacyverklaring | Info | Meiden van Holland',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.privacy && this.pages.privacy.seo ? this.pages.privacy.seo.title : 'Privacyverklaring | Info | Meiden van Holland' },
        { hid: 'og:title', name: 'og:title', content: this.pages.privacy && this.pages.privacy.seo ? this.pages.privacy.seo.title : 'Privacyverklaring | Info | Meiden van Holland' },
        { hid: 'description', name: 'description', content: this.pages.privacy && this.pages.privacy.seo ? this.pages.privacy.seo.description : 'Privacy is voor ons altijd in een belangrijk uitgangspunt geweest. We gaan discreet om met de persoonsgegevens die wij ontvangen.'},
        { hid: 'og:description', name: 'og:description', content: this.pages.privacy && this.pages.privacy.seo ? this.pages.privacy.seo.description : 'Privacy is voor ons altijd in een belangrijk uitgangspunt geweest. We gaan discreet om met de persoonsgegevens die wij ontvangen.' },
        { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/info/privacy' },
        { hid: 'keywords', name: 'keywords', content: this.pages.privacy  && this.pages.privacy.seo ? this.pages.privacy.seo.keywords : 'Privacy, Privacyverklaring' },
      ]
    }
  },
}
